import Dashboard from "../components/Dashboard";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";
import IndiaMap from "../components/IndiaMapComponent";
const DashboardPage = () => {
  return (
    <div style={{}}>
      <div className="sticky-top topHeader z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 ">
        <aside
          style={{
            position: "sticky",
            //top: '20px', // match navbar height
            height: "calc(100vh - 120px)",
            top: "66px",
          }}
        >
          <Sidebar />
        </aside>
        <main
          className="flex-grow-1 p-4 w-25 bg-theme-light"
        >
          <Dashboard />
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};
export default DashboardPage;
